"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var parse_1 = require("../../helpers/parse");
function RadioDirective(config, $parse) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/radio.html',
        controller: /** @class */ (function (_super) {
            __extends(RadioController, _super);
            function RadioController($scope, book, dialog) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.dialog = dialog;
                _this.setSingleCol(false);
                _this.form.value = book.getIndex(_this.prefix, _this.id);
                _this.setValue(_this.form.value);
                return _this;
            }
            RadioController.prototype.setValue = function (value) {
                this.form.value = value;
                this.book.update(this.prefix, this.id, value);
            };
            RadioController.prototype.showDialog = function (callback) {
                var condition = parse_1.evaluateCondition(this.dialogOptions.condition || 'true', this.book);
                var locale = $parse("ui.dialogs." + this.dialogOptions.locale)(config.localeJson);
                if (!locale || !condition) {
                    callback();
                    return;
                }
                var options = {
                    title: locale.title,
                    buttons: [
                        { label: locale.button.cancel, style: 'secondary' },
                        { label: locale.button.ok, callback: callback }
                    ]
                };
                this.dialog.show(locale.text, options);
            };
            RadioController.prototype.onClick = function (value) {
                var _this = this;
                if (this.dialogOptions && this.form.value !== value) {
                    this.showDialog(function () { return _this.setValue(value); });
                }
                else {
                    this.setValue(value);
                }
            };
            return RadioController;
        }(form_1.FormOptionController)),
        controllerAs: 'radioCtrl'
    };
}
exports.RadioDirective = RadioDirective;
